import { getHoursFromOpenCloseValues } from "./get_hours_from_open_close_values";

export function calculateDailyBenefitPercent(
  hourlyPrice = 0,
  dailyPrice = 0,
  openAt?: string,
  closedAt?: string
): number {
  const maxHoursInDay = getHoursFromOpenCloseValues(openAt, closedAt);

  const totalPriceFullDayByHours = hourlyPrice * maxHoursInDay;
  const savedValue = totalPriceFullDayByHours - dailyPrice;

  if (
    !maxHoursInDay ||
    !totalPriceFullDayByHours ||
    savedValue < 0 ||
    !dailyPrice
  ) {
    return 0;
  }

  const savedPercentage = (savedValue / totalPriceFullDayByHours) * 100;

  return Math.round(savedPercentage);
}
